import React from 'react';
import Icon from '../AppIcon';
import Button from './Button';

const ConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  variant = 'default', // 'default', 'danger', 'warning', 'success'
  icon = null,
  children,
  confirmDisabled = false,
  confirmLoading = false,
}) => {
  if (!isOpen) return null;

  const variantStyles = {
    default: {
      iconColor: '#9333EA',
      iconName: 'AlertCircle',
      confirmVariant: 'default'
    },
    danger: {
      iconColor: '#DC2626',
      iconName: 'AlertTriangle',
      confirmVariant: 'destructive'
    },
    warning: {
      iconColor: '#F59E0B',
      iconName: 'AlertTriangle',
      confirmVariant: 'default'
    },
    success: {
      iconColor: '#10B981',
      iconName: 'CheckCircle',
      confirmVariant: 'default'
    }
  };

  const style = variantStyles?.[variant] || variantStyles?.default;
  const displayIcon = icon || style?.iconName;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/50 z-50 animate-in fade-in duration-200"
        onClick={onClose}
      />
      
      {/* Dialog */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none">
        <div 
          className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6 pointer-events-auto animate-in zoom-in-95 duration-200"
          onClick={(e) => e?.stopPropagation()}
        >
          {/* Icon */}
          {displayIcon && (
            <div className="flex justify-center mb-4">
              <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center">
                <Icon name={displayIcon} size={24} color={style?.iconColor} />
              </div>
            </div>
          )}

          {/* Title */}
          <h3 className="text-xl font-bold text-gray-900 text-center mb-2">
            {title}
          </h3>

          {/* Message */}
          <p className="text-gray-600 text-center mb-6">
            {message}
          </p>

          {/* Custom Content */}
          {children && (
            <div className="mb-6">
              {children}
            </div>
          )}

          {/* Actions */}
          <div className="flex gap-3">
            <Button
              variant="outline"
              className="flex-1"
              onClick={onClose}
            >
              {cancelText}
            </Button>
            <Button
              variant={style?.confirmVariant}
              className="flex-1"
              onClick={() => {
                onConfirm?.();
                onClose?.();
              }}
              disabled={confirmDisabled}
              loading={confirmLoading}
            >
              {confirmText}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmDialog;